var module = angular.module('octopusApp.projects');

module.directive('projectEditor', function() {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    templateUrl: 'areas/projects/views/editor.html',
    link: function(scope, element) {
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/directives/project_editor_directive.js
// module id = 1027736119529806
// module chunks = 1